const genAnswer = function (qu, value, refItem) {
  const optionList = qu.optionList
  const otherOption = optionList.find(opt => opt.id === value) || {}
  return [{
    descId: refItem.id,
    answer: value,
    otherAnswer: otherOption.otherValue || ''
  }]
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap) {
  const id = this.id
  let value = valueMap[id] || ''
  if (value) {
    value = value[0]
    const opt = this.optionList.find(item => item.id === value)
    if (opt) {
      opt.otherValue = otherAnswerMap[id] || ''
    }
  }
  this.value = value
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/RadioBox/answer.js